export default "__VITE_ASSET__DUxhDrKh__"